import "./email-component-styles.scss";

// importing icon
import { FaEnvelope } from "react-icons/fa";

const EmailComponent = () => {
	return (
		<div className="email-box">
			<a
				target="_blank"
				title="Contat Email"
				href="mailto:mozalikorai@gmail.com"
				className="email"
			>
				<FaEnvelope />
				mozalikorai@gmail.com
			</a>
		</div>
	);
};

export default EmailComponent;
